import PropTypes from "prop-types";
import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Collapse } from "reactstrap";
import withRouter from "components/Common/withRouter";
import classname from "classnames";
import ShreeRamImage from '../Common/ShreeRamImage';
import MobileSidebar from "./MobileSidebar";
import VoucherAccessModal from "../Common/VoucherAccessModal";
import { useNavigationHistory } from "../../helpers/NavigationHistoryContext";

//i18n
import { withTranslation } from "react-i18next";

import { connect } from "react-redux";
import { toggleLeftmenu } from "store/actions";
import { getCompanyName } from "constants/constAPI";
import { RefreshCw } from "react-feather";

const Navbar = props => {

  const [dashboard, setdashboard] = useState(false);
  const [masters, setmasters] = useState(false);
  const [transaction, settransaction] = useState(false);
  const [reports, setreports] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showLogout, setShowLogout] = useState(window.innerWidth >= 992);
  const [accessModal, setAccessModal] = useState({ open: false, type: 'bro' });
  const { goBack } = useNavigationHistory();

  const navRef = useRef(null);

  useEffect(() => {
    var matchingMenuItem = null;
    var ul = document.getElementById("navigation");
    var items = ul.getElementsByTagName("a");
    removeActivation(items);
    for (var i = 0; i < items.length; ++i) {
      if (window.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  });

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;
      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        if (parent.classList.contains("active")) {
          parent.classList.remove("active");
        }
      }
    }
  };

  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement;
    if (parent) {
      parent.classList.add("active"); // li
      const parent2 = parent.parentElement;
      parent2.classList.add("active"); // li
      const parent3 = parent2.parentElement;
      if (parent3) {
        parent3.classList.add("active"); // li
        const parent4 = parent3.parentElement;
        if (parent4) {
          parent4.classList.add("active"); // li
          const parent5 = parent4.parentElement;
          if (parent5) {
            parent5.classList.add("active"); // li
            const parent6 = parent5.parentElement;
            if (parent6) {
              parent6.classList.add("active"); // li
            }
          }
        }
      }
    }
    return false;
  }

  // Function to close all dropdowns
  const closeAllDropdowns = () => {
    setmasters(false);
    settransaction(false);
    setreports(false);
  };

  // Handle click outside to close dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        closeAllDropdowns();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Handle window resize to toggle logout button visibility
  // Toggle button visible hai to logout hide, toggle hidden hai to logout show
  useEffect(() => {
    const handleResize = () => {
      const isDesktop = window.innerWidth >= 992;
      setShowLogout(isDesktop);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Global Refresh State & Logic
  const [isRefreshing, setIsRefreshing] = useState(false);
  useEffect(() => {
    const handleStart = () => setIsRefreshing(true);
    const handleEnd = () => setIsRefreshing(false);
    window.addEventListener('app-refresh-start', handleStart);
    window.addEventListener('app-refresh-end', handleEnd);
    return () => {
      window.removeEventListener('app-refresh-start', handleStart);
      window.removeEventListener('app-refresh-end', handleEnd);
    };
  }, []);

  const handleGlobalRefresh = () => {
    if (isRefreshing) return;
    const event = new CustomEvent('app-refresh-data', { cancelable: true });
    const canceled = !window.dispatchEvent(event);
    if (!canceled) {
      // If no page handles it (or doesn't call preventDefault), we just spin shortly
      setIsRefreshing(true);
      setTimeout(() => setIsRefreshing(false), 500);
    }
  };

  return (
    <React.Fragment>
      {/* Mobile Sidebar */}
      <MobileSidebar
        isOpen={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(false)}
        t={props.t}
      />

      <div className="topnav" style={{ padding: '2px 0', height: '36px' }}>
        <div className="container-fluid" style={{ padding: '0' }}>
          <nav
            ref={navRef}
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
            style={{ padding: '0', minHeight: '32px', height: '32px', position: 'relative' }}
          >
            {/* Mobile: Toggle Button + Logo + Title on same line */}
            <div className="d-flex align-items-center w-100 w-lg-auto" style={{ padding: '0', height: '28px', marginRight: '24px' }}>
              {/* Mobile Toggle Button */}
              <button
                className="navbar-toggler d-lg-none"
                type="button"
                onClick={() => setMobileMenuOpen(true)}
                aria-label="Toggle navigation"
                style={{
                  border: '1px solid #dee2e6',
                  background: '#fff',
                  color: '#495057',
                  padding: '0.25rem 0.5rem',
                  borderRadius: '4px',
                  marginRight: '0.5rem',
                  position: 'relative',
                  zIndex: 100
                }}
              >
                <i className="fa fa-fw fa-bars" style={{ fontSize: '14px' }} />
              </button>

              {/* Global Refresh Button */}
              <button
                type="button"
                onClick={handleGlobalRefresh}
                title="Refresh Data"
                className="d-lg-none"
                style={{
                  padding: '4px',
                  background: 'transparent',
                  border: 'none',
                  cursor: isRefreshing ? 'not-allowed' : 'pointer',
                  color: '#ffffff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  opacity: isRefreshing ? 0.6 : 1,
                }}
              >
                <RefreshCw size={20} strokeWidth={3} style={isRefreshing ? { animation: 'spin 1s linear infinite' } : {}} />
              </button>

              {/* Logo - adjusted margin for refresh button */}
              <ShreeRamImage
                alt="Shinewell Softtech Logo"
                onDoubleClick={() => setAccessModal({ open: true, type: 'bro' })}
                portraitStyle={{ height: '28px', width: 'auto', marginLeft: '10px', marginRight: '20px', borderRadius: '4px', cursor: 'pointer' }}
                landscapeStyle={{ height: '28px', width: 'auto', marginLeft: '10px', marginRight: '20px', borderRadius: '4px', cursor: 'pointer' }}
              />

              {/* Company Title */}
              <span
                className="company-title"
                onDoubleClick={() => setAccessModal({ open: true, type: 'hidden' })}
                style={{
                  fontSize: '12px',
                  fontWeight: 'bold',
                  color: '#495057',
                  marginRight: '8px',
                  marginLeft: '4px',
                  whiteSpace: 'nowrap',
                  lineHeight: '1.2',
                  cursor: 'pointer'
                }}
              >
                {getCompanyName()}
              </span>

              {/* Back Button - mobile only, arrow icon only, right after company name */}
              <button
                type="button"
                onClick={goBack}
                title="Go Back"
                className="d-lg-none"
                style={{
                  padding: '4px',
                  fontSize: '22px',
                  height: '30px',
                  display: 'flex',
                  alignItems: 'center',
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  color: '#ffffff',
                  fontWeight: 'bold',
                  marginLeft: '4px'
                }}
              >
                <i className="bx bx-undo" style={{ fontWeight: '900' }} />
              </button>
            </div>




            <div className="collapse navbar-collapse d-none d-lg-flex" id="topnav-menu-content">
              <ul className="navbar-nav" style={{ padding: '0', height: '28px', alignItems: 'center' }}>
                <li className="nav-item dropdown">
                  <a href="/dashboard" target="_blank" rel="noopener noreferrer" className="nav-link" style={{ padding: '2px 6px', fontSize: '11px', height: '24px', display: 'flex', alignItems: 'center' }}>
                    {props.t("Dashboard")}
                  </a>

                </li>

                {/* Vertical Layout Sidebar Content - Masters Section */}
                <li className="nav-item dropdown" onMouseLeave={() => setmasters(false)}>
                  <a
                    className="nav-link dropdown-toggle arrow-none"
                    style={{ padding: '2px 6px', fontSize: '11px', height: '24px', display: 'flex', alignItems: 'center' }}
                    href="/#"
                    onClick={e => {
                      e.preventDefault();
                      setmasters(!masters);
                      settransaction(false);
                      setreports(false);
                    }}
                  >
                    <i className="bx bx-store me-1" style={{ fontSize: '10px' }}></i>
                    {props.t("Masters")} <div className="arrow-down" style={{ fontSize: '8px' }}></div>
                  </a>
                  <div className={classname("dropdown-menu", { show: masters })}>
                    <a href="/ItemMaster" target="_blank" rel="noopener noreferrer" className="dropdown-item" onClick={() => setmasters(false)}>
                      {props.t("Item Master")}
                    </a>
                    <a href="/PartyAccountMaster" target="_blank" rel="noopener noreferrer" className="dropdown-item" onClick={() => setmasters(false)}>
                      {props.t("Party Acc Master")}
                    </a>
                    <a href="/LedgerMaster" target="_blank" rel="noopener noreferrer" className="dropdown-item" onClick={() => setmasters(false)}>
                      {props.t("Bro Dr/Cr Master")}
                    </a>
                    <a href="/UnitMaster" target="_blank" rel="noopener noreferrer" className="dropdown-item" onClick={() => setmasters(false)}>
                      {props.t("Unit Master")}
                    </a>
                    <a href="/ContractTypeMaster" target="_blank" rel="noopener noreferrer" className="dropdown-item" onClick={() => setmasters(false)}>
                      {props.t("Contract Type")}
                    </a>
                    <a href="/TransportMaster" target="_blank" rel="noopener noreferrer" className="dropdown-item" onClick={() => setmasters(false)}>
                      {props.t("Transport Master")}
                    </a>

                    {/* <a href="/StateMaster" target="_blank" rel="noopener noreferrer" className="dropdown-item">
                      {props.t("State Master")}
                    </a> */}
                  </div>
                </li>

                {/* Vertical Layout Sidebar Content - Transaction Section */}
                <li className="nav-item dropdown" onMouseLeave={() => settransaction(false)}>
                  <a
                    className="nav-link dropdown-toggle arrow-none"
                    style={{ padding: '2px 6px', fontSize: '11px', height: '24px', display: 'flex', alignItems: 'center' }}
                    href="/#"
                    onClick={e => {
                      e.preventDefault();
                      settransaction(!transaction);
                      setmasters(false);
                      setreports(false);
                    }}
                  >
                    <i className="bx bx-file me-1" style={{ fontSize: '10px' }}></i>
                    {props.t("Transaction")} <div className="arrow-down" style={{ fontSize: '8px' }}></div>
                  </a>
                  <div className={classname("dropdown-menu", { show: transaction })}>
                    <a href="/Contract" target="_blank" rel="noopener noreferrer" className="dropdown-item" onClick={() => settransaction(false)}>
                      {props.t("Contract")}
                    </a>
                    <a href="/UpdateGlobalOptions" target="_blank" rel="noopener noreferrer" className="dropdown-item" onClick={() => settransaction(false)}>
                      {props.t("Firm Master")}
                    </a>
                  </div>
                </li>

                {/* Vertical Layout Sidebar Content - Reports Section */}
                <li className="nav-item dropdown" onMouseLeave={() => setreports(false)}>
                  <a
                    className="nav-link dropdown-toggle arrow-none"
                    style={{ padding: '2px 6px', fontSize: '11px', height: '24px', display: 'flex', alignItems: 'center' }}
                    href="/#"
                    onClick={e => {
                      e.preventDefault();
                      setreports(!reports);
                      setmasters(false);
                      settransaction(false);
                    }}
                  >
                    <i className="bx bx-file-find me-1" style={{ fontSize: '10px' }}></i>
                    {props.t("Reports")} <div className="arrow-down" style={{ fontSize: '8px' }}></div>
                  </a>
                  <div className={classname("dropdown-menu", { show: reports })}>
                    <a href="/NewLedgerReport" target="_blank" rel="noopener noreferrer" className="dropdown-item" onClick={() => setreports(false)}>
                      {props.t("Ledger List")}
                    </a>

                    <a href="/MultiPrint" target="_blank" rel="noopener noreferrer" className="dropdown-item" onClick={() => setreports(false)}>
                      {props.t("Multi Print")}
                    </a>


                    <a href="/ContractRegister" target="_blank" rel="noopener noreferrer" className="dropdown-item" onClick={() => setreports(false)}>
                      {props.t("Contract Register")}
                    </a>
                    <a href="/BrokerageCalculation" target="_blank" rel="noopener noreferrer" className="dropdown-item" onClick={() => setreports(false)}>
                      {props.t("Bro Dr/Cr Register")}
                    </a>
                    <a href="/VoucherList" target="_blank" rel="noopener noreferrer" className="dropdown-item" onClick={() => setreports(false)}>
                      {props.t("Brokerage Voucher Register")}
                    </a>
                    <a href="/LinkCreateRegister" target="_blank" rel="noopener noreferrer" className="dropdown-item" onClick={() => setreports(false)}>
                      {props.t("Link Register")}
                    </a>
                    <a href="/LinkRegisterShow" target="_blank" rel="noopener noreferrer" className="dropdown-item" onClick={() => setreports(false)}>
                      {props.t("Link Register Show")}
                    </a>
                    <a href="/ReminderData" target="_blank" rel="noopener noreferrer" className="dropdown-item" onClick={() => setreports(false)}>
                      {props.t("Reminder Data")}
                    </a>
                    <div className="dropdown-divider"></div>
                    <a href="/SaudaPositionReport" target="_blank" rel="noopener noreferrer" className="dropdown-item" onClick={() => setreports(false)}>
                      {props.t("Sauda Position")}
                    </a>
                    <a href="/PendingLiftingTracker" target="_blank" rel="noopener noreferrer" className="dropdown-item" onClick={() => setreports(false)}>
                      {props.t("Pending Lifting Tracker")}
                    </a>
                    <a href="/WashoutRegister" target="_blank" rel="noopener noreferrer" className="dropdown-item" onClick={() => setreports(false)}>
                      {props.t("Washout Register")}
                    </a>
                    <a href="/PartyOutstandingReport" target="_blank" rel="noopener noreferrer" className="dropdown-item" onClick={() => setreports(false)}>
                      {props.t("Party Outstanding Aging")}
                    </a>
                    <a href="/BrokerPerformanceReport" target="_blank" rel="noopener noreferrer" className="dropdown-item" onClick={() => setreports(false)}>
                      {props.t("Broker Performance")}
                    </a>
                  </div>
                </li>
              </ul>
            </div>

            {/* Back & Refresh Button - desktop only, centered in navbar */}
            {showLogout && (
            <div style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)', display: 'flex', gap: '8px', alignItems: 'center' }}>
              <button
                type="button"
                onClick={goBack}
                title="Go Back"
                style={{
                  padding: '2px 12px',
                  fontSize: '10px',
                  height: '22px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  background: 'transparent',
                  border: '1px solid #dee2e6',
                  borderRadius: '50px',
                  cursor: 'pointer',
                  color: '#ffffff',
                  fontWeight: 'bold'
                }}
              >
                <i className="bx bx-undo" style={{ fontSize: '13px' }} />
                <span>Back</span>
              </button>

              <button
                type="button"
                onClick={handleGlobalRefresh}
                disabled={isRefreshing}
                title="Refresh data"
                style={{
                  width: '22px',
                  height: '22px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: 'transparent',
                  border: '1px solid #dee2e6',
                  borderRadius: '50%',
                  cursor: isRefreshing ? 'not-allowed' : 'pointer',
                  color: '#ffffff',
                  padding: 0,
                  opacity: isRefreshing ? 0.6 : 1,
                }}
              >
                <RefreshCw size={12} style={isRefreshing ? { animation: 'spin 1s linear infinite' } : {}} />
              </button>
            </div>
            )}

            {/* Logout Button - Hide when toggle button is visible (mobile), show when toggle hidden (desktop) */}
            {showLogout && (
              <div className="navbar-nav ms-auto">
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => {
                    localStorage.removeItem("authUser");
                    try {
                      localStorage.removeItem("dashboardCustomFromDate");
                      localStorage.removeItem("globalFromDate");
                      localStorage.removeItem("globalToDate");
                    } catch (e) {}
                    window.location.href = "/logout";
                  }}
                  style={{
                    padding: '2px 6px',
                    fontSize: '10px',
                    height: '22px',
                    display: 'flex',
                    alignItems: 'center',
                    minWidth: '50px'
                  }}
                >
                  <i className="bx bx-power-off me-1" style={{ fontSize: '10px' }} />
                  <span className="d-none d-xl-inline-block">Logout</span>
                </button>
              </div>
            )}
          </nav>
        </div>
      </div>
      <VoucherAccessModal
        isOpen={accessModal.open}
        type={accessModal.type}
        toggle={() => setAccessModal({ ...accessModal, open: !accessModal.open })}
      />
    </React.Fragment>
  );
};

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
};

const mapStatetoProps = state => {
  const { leftMenu } = state.Layout;
  return { leftMenu };
};

const mapDispatchToProps = dispatch => {
  return {
    toggleLeftmenu: (value) => dispatch(toggleLeftmenu(value))
  };
};

export default withRouter(
  connect(mapStatetoProps, mapDispatchToProps)(withTranslation()(Navbar))
);
